import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Box, Grid, Typography, CircularProgress } from '@mui/material';
import { Pendingwarning } from 'component/BuyersMarketplace/Marketplaceicons';
import ssl from 'assets/images/ssl.png';
import { PdfIcon } from 'component/BuyersMarketplace/Marketplaceicons';
import { Share } from 'component/BuyersMarketplace/Marketplaceicons';
import { useState, useEffect } from 'react';
import Loading from 'assets/images/loading.png';
import { postApiCall } from 'api/apiService';

export default function DepositEftPdf({
  open,
  setSecureOpen,
  getBuyerIndividualValue,
  setPaymentPop,
  setDepositeopen,
}) {
  const address =
    getBuyerIndividualValue?.PropertyDetails?.propertyAddress?.streetName;
  const localdata = localStorage.getItem('userDetail');
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches900 = useMediaQuery(theme.breakpoints.down(900));

  const [pdfEmbedUrl, setPdfEmbedUrl] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const [pdfBlobUrl, setPdfBlobUrl] = useState(null);

  useEffect(() => {
    const fetchPdf = async () => {
      if (!open) return;

      const accesstoken = 'Bearer ' + localStorage.getItem('accesstoken');
      const url = getBuyerIndividualValue?.depositURL;

      if (!url) {
        console.error('No deposit URL available');
        setIsLoading(false);
        return;
      }

      setIsLoading(true);

      try {
        const response = await fetch(url, {
          headers: {
            Authorization: accesstoken,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch PDF');
        }

        const blob = await response.blob();
        const blobUrl = URL.createObjectURL(blob);

        if (pdfBlobUrl) URL.revokeObjectURL(pdfBlobUrl);

        setPdfBlobUrl(blobUrl);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

    fetchPdf();
    return () => {
      if (pdfBlobUrl) {
        URL.revokeObjectURL(pdfBlobUrl);
        setPdfBlobUrl(null);
      }
    };
  }, [open, getBuyerIndividualValue?.depositURL]);

  const handleLoad = () => {
    setIsLoading(false);
  };

  useEffect(() => {
    if (isLoading) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [isLoading]);

  return (
    <Dialog
      open={open}
      fullScreen={matches700}
      PaperProps={{
        sx: {
          borderRadius: '5px',
          width: '100%',
          maxWidth: '895px',
          paddingBottom: matches700 && '40px',
          '& .MuiDialogContent-root': {
            overflow: 'visible',
          },
        },
      }}
    >
      <Grid container height={'100%'}>
        <Grid container xs={12} sx={{ padding: matchessm ? '10px' : '30px' }}>
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
            }}
          >
            <Typography
              sx={{
                fontFamily: 'poppins',
                fontWeight: 400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {address}
            </Typography>
          </Grid>
          <Grid
            item
            container
            xs={9}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '20px',
              pt: '30px',
            }}
          >
            <Grid
              item
              sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}
            >
              <Pendingwarning />
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '16px' : '24px',
                }}
              >
                Secure Deposit Payment Details
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '12px' : '16px',
                  color: '#666666',
                }}
              >
                Below are the Electronic Funds Transfer (EFT) Deposit Payment
                details for{' '}
                <Box component="span">
                  <b
                    style={{
                      fontFamily: 'Poppins',
                      fontWeight: 550,
                      color: '#666666',
                    }}
                  >
                    {address}
                  </b>
                </Box>
                .
              </Typography>
            </Grid>
          </Grid>
          <Grid
            item
            xs={3}
            sx={{
              display: 'flex',
              justifyContent: 'flex-end',
              alignItems: 'center',
            }}
          >
            <PdfIcon matches500={matches500} />
          </Grid>
        </Grid>
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          sx={{
            width: '100%',
            padding: matches900 ? '10px' : '20px',
          }}
        >
          {isLoading && (
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{
                width: '100%',
                height: '600px',
              }}
            >
              <img
                alt="Logo"
                src={Loading}
                className="loaderImage"
                style={{ height: '40px', width: '40px' }}
              />
            </Grid>
          )}

          <Box
            sx={{
              width: '100%',
              maxWidth: '100%',
              aspectRatio: '16/9',
              overflow: 'hidden',
            }}
          >
            <iframe
              src={pdfBlobUrl}
              width="100%"
              height="100%"
              style={{ border: 'none' }}
              title="PDF Viewer"
              onLoad={handleLoad}
            />
          </Box>
        </Grid>
        <Grid
          item
          container
          sx={{
            position: 'sticky',
            bottom: 0,
            backgroundColor: 'white',
            zIndex: 1000,
            padding: matches900 ? '10px 30px 10px 30px' : '40px 30px 20px 30px',
            display: 'flex',
            flexDirection: matches700 ? 'column' : 'row',
            justifyContent: 'space-between',
            gap: matches700 && '30px',
          }}
        >
          <Grid item>
            <img alt="Logo" src={ssl} />
          </Grid>
          <Grid
            item
            sx={{
              display: 'flex',
              flexDirection: matches500 && 'column',
              gap: '20px',
              justifyContent: matches700 && 'flex-end',
            }}
          >
            <Grid item>
              <Button
                onClick={() => {
                  setSecureOpen(false);
                  setDepositeopen(true);
                }}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '15px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 20px' : '10px 30px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '15px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                  gap: '10px',
                }}
              >
                <Share /> Share
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 30px' : '10px 40px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '15px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={() => {
                  setPaymentPop(true);
                  setSecureOpen(false);
                  setDepositeopen(false);
                }}
              >
                Upload Remittance
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
}
